module.exports = __webpack_public_path__ + "img/b_KalsiyForte_border.a7c072b1.jpeg";